import TextField from "../../ui/TextField";
import { useState } from "react";
import { Box, Button, Dialog, DialogContent, DialogTitle, MenuItem, Typography } from "@mui/material";
import { useInventarios } from "../../../context/Inventarios/InventariosContext";

export default function ImportarConteosModal({
  open,
  folioInventario,
  almacenExhibidor,
  conteosImportados = [],
  onClose,
  onImported,
}) {
  const [conteoNumero, setConteoNumero] = useState(1);
  const [loading, setLoading] = useState(false);

  const { handleTomaImportarConteos } = useInventarios();

  const importar = async () => {
    setLoading(true);
    try {
      await handleTomaImportarConteos({
        ConteoNumero: conteoNumero,
      });
      onImported?.();
      onClose?.();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Importar Conteos</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mt: 1 }}>
          Importa desde <b>Conteos</b> hacia <b>D_TomaInventario</b>.
        </Typography>

        <Box mt={2} display="flex" gap={2}>
          <TextField autoComplete="off"
            select
            label="Conteo"
            value={conteoNumero}
            onChange={(e) => setConteoNumero(Number(e.target.value))}
            fullWidth
          >
            <MenuItem value={1}>
              Conteo 1{conteosImportados.includes(1) ? " (importado)" : ""}
            </MenuItem>
            <MenuItem value={2}>
              Conteo 2{conteosImportados.includes(2) ? " (importado)" : ""}
            </MenuItem>
            <MenuItem value={3}>
              Conteo 3{conteosImportados.includes(3) ? " (importado)" : ""}
            </MenuItem>
          </TextField>
        </Box>

        <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
          <Button onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={importar}
            disabled={loading || !almacenExhibidor || !folioInventario}
          >
            Importar
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}